import React from "react";
//import classNames from "classnames";
//import { Link } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
//import MenuItem from "@material-ui/core/MenuItem";
//import MenuList from "@material-ui/core/MenuList";
//import Grow from "@material-ui/core/Grow";
//import Paper from "@material-ui/core/Paper";
//import ClickAwayListener from "@material-ui/core/ClickAwayListener";
//import Hidden from "@material-ui/core/Hidden";
//import Poppers from "@material-ui/core/Popper";
//import Divider from "@material-ui/core/Divider";
// @material-ui/icons
//import Person from "@material-ui/icons/Person";
//import Notifications from "@material-ui/icons/Notifications";
// core components
//import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";

const useStyles = makeStyles(styles);

export default function HomeNavbarLinks() {
    const classes = useStyles();
    return (
        <div>
            <div className={classes.manager}>

            </div>
        </div>
    );
}
